import { prepareJourneyOrFollowUpTriggers } from '../utils/triggerJourneysAndFollowUps';

export function initFollowUpCampaigns(context) {
  if (context.config.followUpCampaigns?.length) {
    context.config.followUpCampaigns.forEach((campaign) => {
      prepareJourneyOrFollowUpTriggers(campaign, context.triggerFollowUpEvent, context.triggerJourneyEvent);
    });
  }

  if (context.config.shopifyCartAbandonmentFollowUpCampaignId) {
    const addToCartButtons = document.querySelectorAll('button[name="add"], button.addtocart, a.add-to-cart');
    for (let addToCartButtonIndex = 0; addToCartButtonIndex < addToCartButtons.length; addToCartButtonIndex += 1) {
      const addToCartButton = addToCartButtons[addToCartButtonIndex];
      if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
          context.triggerFollowUpEvent(context.config.shopifyCartAbandonmentFollowUpCampaignId, 'addToCart');
        }, true);
      }
    }

    if (
      (document.documentElement
        && document.documentElement.className
        && document.documentElement.className.indexOf('page--thank-you') > -1)
      || (window.location && window.location.pathname
        && window.location.pathname.indexOf('thank_you') > -1)
    ) {
      context.triggerFollowUpEvent(context.config.shopifyCartAbandonmentFollowUpCampaignId, 'checkout');
    }
  }

  if (context.config.epagesCartAbandonmentFollowUpCampaignId) {
    const addToCartButton = document.querySelector('button.product-add-cart-button');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', () => {
        context.triggerFollowUpEvent(context.config.epagesCartAbandonmentFollowUpCampaignId, 'addToCart');
      }, true);
    }

    if (
      (document.documentElement
        && document.documentElement.className
        && document.documentElement.className.indexOf('page--thank-you') > -1)
      || (window.location
        && window.location.pathname
        && window.location.pathname.indexOf('thank_you') > -1)
    ) {
      context.triggerFollowUpEvent(context.config.epagesCartAbandonmentFollowUpCampaignId, 'checkout');
    }
  }
}
